module.exports = __webpack_public_path__ + "img/loginBg.613de8a0.png";